import authAxios from '../common/authAxios';
import Constants from '../common/constants';

const adminQueueService = {
	// ─── Service Types ───────────────────────────────────────────────────────
	getAllServiceTypes: (page = 0, size = 50) =>
		authAxios.get(
			`${Constants.API_BASE_URL}/queue/service-type?page=${page}&size=${size}`
		),

	createServiceType: (data) =>
		authAxios.post(`${Constants.API_BASE_URL}/queue/service-type`, data),

	updateServiceType: (id, data) =>
		authAxios.put(`${Constants.API_BASE_URL}/queue/service-type/${id}`, data),

	deleteServiceType: (id) =>
		authAxios.delete(`${Constants.API_BASE_URL}/queue/service-type/${id}`),

	importServiceTypes: (file) => {
		const formData = new FormData();
		formData.append('file', file);
		return authAxios.post(
			`${Constants.API_BASE_URL}/queue/service-type/import`,
			formData
		);
	},

	downloadServiceTypeTemplate: () =>
		authAxios.get(
			`${Constants.API_BASE_URL}/queue/service-type/import/template`,
			{ responseType: 'blob' }
		),

	// ─── Managers ───────────────────────────────────────────────────────────
	getAllManagers: (page = 0, size = 20) =>
		authAxios.get(
			`${Constants.API_BASE_URL}/queue/manager?page=${page}&size=${size}`
		),

	getManagerById: (id) =>
		authAxios.get(`${Constants.API_BASE_URL}/queue/manager/${id}`),

	createManager: (data) =>
		authAxios.post(`${Constants.API_BASE_URL}/queue/manager`, data),

	updateManager: (id, data) =>
		authAxios.put(`${Constants.API_BASE_URL}/queue/manager/${id}`, data),

	deleteManager: (id) =>
		authAxios.delete(`${Constants.API_BASE_URL}/queue/manager/${id}`),

	activateManager: (id) =>
		authAxios.get(`${Constants.API_BASE_URL}/queue/manager/activate/${id}`),

	deactivateManager: (id) =>
		authAxios.get(`${Constants.API_BASE_URL}/queue/manager/deactivate/${id}`),

	importManagers: (file) => {
		const formData = new FormData();
		formData.append('file', file);
		return authAxios.post(
			`${Constants.API_BASE_URL}/queue/manager/import`,
			formData
		);
	},

	downloadManagerTemplate: () =>
		authAxios.get(
			`${Constants.API_BASE_URL}/queue/manager/import/template`,
			{ responseType: 'blob' }
		),

	// ─── Windows (справочник окон) ────────────────────────────────────────────
	getWindows: () =>
		authAxios.get(`${Constants.API_BASE_URL}/queue/window`),

	// ─── Admin Tickets ───────────────────────────────────────────────────────
	getAllTicketsAdmin: ({ status, managerId, serviceTypeId, dateFrom, dateTo, page = 0, size = 20 } = {}) => {
		const params = new URLSearchParams({ page, size });
		if (status)        params.append('status', status);
		if (managerId)     params.append('managerId', managerId);
		if (serviceTypeId) params.append('serviceTypeId', serviceTypeId);
		if (dateFrom)      params.append('dateFrom', dateFrom);
		if (dateTo)        params.append('dateTo', dateTo);
		return authAxios.get(`${Constants.API_BASE_URL}/queue/ticket/admin?${params}`);
	},

	deleteTicketAdmin: (id) =>
		authAxios.delete(`${Constants.API_BASE_URL}/queue/ticket/admin/${id}`),

	getTicketStats: ({ dateFrom, dateTo } = {}) => {
		const params = new URLSearchParams();
		if (dateFrom) params.append('dateFrom', dateFrom);
		if (dateTo)   params.append('dateTo',   dateTo);
		const qs = params.toString();
		return authAxios.get(`${Constants.API_BASE_URL}/queue/ticket/admin/stats${qs ? '?' + qs : ''}`);
	},

	exportTicketsAdmin: ({ status, managerId, serviceTypeId, dateFrom, dateTo, lang, format } = {}) => {
		const params = new URLSearchParams();
		if (status)        params.append('status', status);
		if (managerId)     params.append('managerId', managerId);
		if (serviceTypeId) params.append('serviceTypeId', serviceTypeId);
		if (dateFrom)      params.append('dateFrom', dateFrom);
		if (dateTo)        params.append('dateTo', dateTo);
		if (lang)          params.append('lang', lang);
		if (format)        params.append('format', format);
		const qs = params.toString();
		return authAxios.get(`${Constants.API_BASE_URL}/queue/ticket/admin/export${qs ? '?' + qs : ''}`, {
			responseType: 'blob',
		});
	},
};

export default adminQueueService;
